import React from 'react'
import { createUseStyles } from 'react-jss'
import obj2Arr from '../../utils/obj2Arr'

const useStyles = createUseStyles(theme => ({
  maincontainer: {
    padding: '45px 0',
    '@media (max-width: 1200px)': {
      boxSizing: 'border-box',
      padding: '25px 35px',
    },
    '@media (max-width: 700px)': {
      boxSizing: 'border-box',
      padding: '25px 15px',
    },
  },
  container: {
    '& > div': {
      margin: '0 auto',
      width: '100%',
      maxWidth: '1220px',
      '@media (max-width: 1220px)': {
        width: 'auto',
        boxSizing: 'border-box',
        marginLeft: 15,
        marginRight: 15,
      },
    },
    '& + &': {
      marginTop: '40px',
    },
    '& *': {
      boxSizing: 'border-box',
    },
  },
  wrapper: {
    display: 'grid',
    justifyContent: 'space-evenly',
    gridGap: '40px',
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr !important',
    },
  },
  contenti: {
    padding: '17px 0',
  },
  image: {
    '& img': {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '20px',
      verticalAlign: 'bottom',
    },
  },
  title: {
    fontSize: '32px',
    lineHeight: 1.4,
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'left',
    padding: '0',
    marginBottom: 16,
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
  details: {
    fontSize: '18px',
    lineHeight: 1.5,
    fontWeight: 300,
    fontFamily: 'AvenirNextLTPro',
    textAlign: 'left',
    '& ul': {
      '& li': { marginBottom: 7 },
      '& a': {
        color: theme.colors.main,
        textDecoration: 'underline',
        '&:hover': {
          color: theme.colors.main,
          textDecoration: 'underline',
          fontWeight: 'bold',
        },
      },
    },
    '& p': {
      margin: 0,
      '& + p': {
        marginTop: 15,
        '@media (max-width: 600px)': {
          marginTop: 15,
        },
      },

      '& a': {
        color: theme.colors.main,
        textDecoration: 'underline',
        '&:hover': {
          color: theme.colors.main,
          textDecoration: 'underline',
          fontWeight: 'bold',
        },
      },
    },
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
  innerCTA: {
    textAlign: 'left',
    marginTop: '20px',
  },
}))

const DoubleTextContentContainer = props => {
  const { blocks } = props

  const classes = useStyles()

  const objArr = obj2Arr(blocks)
  return (
    <div className={classes.maincontainer}>
      {objArr &&
        objArr.map((block, i) => {
          const {
            alignitems,
            titleRight,
            detailsRight,
            titleLeft,
            detailsLeft,
            titlefontsize,
            detailsfontsize,
            textcolor,
          } = block

          return (
            <div
              className={classes.container}
              key={i}
              style={{
                padding: '0',
              }}
            >
              <div
                className={classes.wrapper}
                style={{
                  alignItems: alignitems,
                  gridTemplateColumns: '1fr 1fr',
                }}
              >
                <div className={classes.text}>
                  <div
                    className={classes.title}
                    style={{
                      fontSize: titlefontsize,
                      color: textcolor === 'blue' ? '#007AC3' : textcolor,
                    }}
                  >
                    {titleLeft}
                  </div>

                  <div
                    className={classes.details}
                    style={{
                      fontSize: detailsfontsize,
                      color: textcolor === 'blue' ? '#000' : textcolor,
                    }}
                    dangerouslySetInnerHTML={{ __html: detailsLeft }}
                  />
                </div>
                <div className={classes.text}>
                  <div
                    className={classes.title}
                    style={{
                      fontSize: titlefontsize,
                      color: textcolor === 'blue' ? '#007AC3' : textcolor,
                    }}
                  >
                    {titleRight}
                  </div>
                  <div
                    className={classes.details}
                    style={{
                      fontSize: detailsfontsize,
                      color: textcolor === 'blue' ? '#000' : textcolor,
                    }}
                    dangerouslySetInnerHTML={{ __html: detailsRight }}
                  />
                </div>
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default DoubleTextContentContainer
